import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Root } from './MyProfile.css';
import * as reducer from './MyProfile.reducer';
import PageTitle from '../Layout/components/PageTitle'
import { TextField, MenuItem, FormGroup, Checkbox, FormLabel, FormControlLabel, Button } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { roleStr, roleName, roleInfo } from '../../common/common';
import { timeFormat } from '../../common/utils';
import { fromJS } from 'immutable';
import Toast from '../Layout/components/Toast';
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';

const ADMIN = "admin";
class MyProfile extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            rolePermissions: false,
            workPermissions: false,
            showToast: false,
            toastMsg: "",
            toastState: "",
            roles: [],
            myTeams: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            showToast,
            toastMsg,
            toastState,
            roles,
            myTeams,
        } = this.state;
        const { infoList } = this.props;
        const roleFrom = () => {
            if (this.state.rolePermissions) {
                return <div>
                    <FormLabel component="legend">Choose role</FormLabel>
                    <FormGroup aria-label="position" name="position" row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Administrator"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Client Manager"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Billing Manager"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Department Manager"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Team Leader"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    //   checked={state.checkedB}
                                    //   onChange={handleChange('checkedB')}
                                    value="checkedB"
                                    color="primary"
                                />
                            }
                            label="Staff"
                        />
                    </FormGroup>
                </div>
            }
        }
        const workFrom = () => {
            if (this.state.workPermissions) {
                return <div>
                    <div className="title">Work Info</div>
                    <div className="line"></div>
                    <div>
                        <TextField
                            id="outlined-select-currency"
                            select
                            label="Office"
                            className="textField"
                            // value={values.currency}
                            // onChange={handleChange('currency')}
                            // SelectProps={{
                            //     MenuProps: {
                            //         className: classes.menu,
                            //     },
                            // }}
                            margin="dense"
                            variant="outlined"
                        >
                            {this.state.currencies.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            id="outlined-select-currency"
                            select
                            label="Department"
                            className="textField"
                            // value={values.currency}
                            // onChange={handleChange('currency')}
                            // SelectProps={{
                            //     MenuProps: {
                            //         className: classes.menu,
                            //     },
                            // }}
                            margin="dense"
                            variant="outlined"
                        >
                            {this.state.currencies.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            id="outlined-select-currency"
                            select
                            label="Team"
                            className="textField"
                            // value={values.currency}
                            // onChange={handleChange('currency')}
                            // SelectProps={{
                            //     MenuProps: {
                            //         className: classes.menu,
                            //     },
                            // }}
                            margin="dense"
                            variant="outlined"
                        >
                            {this.state.currencies.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <div className="textField"></div>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                className="textField"
                                margin="dense"
                                id="mui-pickers-date"
                                label="Hire date"
                                value={this.state.selectedDate}
                                onChange={this.handleDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        <div className="iconTextField h h-c">
                            <span className="icon">$</span>
                            <TextField
                                id="outlined-required"
                                label="SALARY AMOUNT"
                                className="f"
                                margin="dense"
                                variant="outlined"
                            />
                        </div>
                    </div>
                </div>
            }
        }
        const workInfoView = () => {
            if (roleName !== ADMIN) {
                return <div>
                    <TextField
                        disabled={true}
                        label="Hire Date"
                        className="textField"
                        margin="dense"
                        variant="outlined"
                        value={timeFormat(infoList.toJS().hire_date)}
                    />
                    {/* <div className="iconTextField h h-c">
                        <span className="icon">$</span>
                        <TextField
                            disabled={true}
                            label="Hour rate"
                            className="rateText"
                            margin="dense"
                            variant="outlined"
                            value={infoList.toJS().rate || ""}
                        />
                        <TextField
                            disabled={true}
                            label="SALARY AMOUNT"
                            className="f"
                            margin="dense"
                            variant="outlined"
                            value={infoList.toJS().salary || ""}
                        />
                    </div> */}
                    <div className="workWapper">
                        {myTeams.map((option, index) => (
                            <div key={index}>
                                {option}
                            </div>
                        ))}
                    </div>
                    {/* <div className="workWapper">
                        {(infoList.toJS().departments ? infoList.toJS().departments : []).map((option, index) => (
                            <div key={index}>
                                <b>Department:</b> {option.office} - {option.name} ( {this.changeRoleName(option.role_id)} )
                            </div>
                        ))}
                        {(infoList.toJS().teams ? infoList.toJS().teams : []).map((option, index) => (
                            <div key={index}>
                                <b>Team:</b> {option.dept.office} - {option.dept.name} - {option.name} ( {this.changeRoleName(option.role_id)} )
                            </div>
                        ))}
                    </div> */}
                </div>
            }
        }
        return (
            <Root>
                <PageTitle title="MY PROFILE" subtitle="MANAGEMENT"></PageTitle>
                <div className="wapper h h-t">
                    <div className="info">
                        <div className="user h h-t">
                            <div className="f">
                                <div className="username">{infoList.toJS().first_name} {infoList.toJS().last_name}</div>
                                <div className="profession">{infoList.toJS().position}</div>
                            </div>
                            <div className="avatar"></div>
                        </div>
                        <div className="line"></div>
                        <div className="h">
                            <div className="font-btn">UPLOAD PICTURE</div>
                            <div className="font-btn">REMOVE PICTURE</div>
                        </div>
                    </div>
                    <div className="details">
                        <form noValidate autoComplete="off">
                            <div className="title">Personal Info</div>
                            <div className="line"></div>
                            <div>
                                <TextField
                                    required
                                    label="First name"
                                    className="textField"
                                    margin="dense"
                                    variant="outlined"
                                    value={infoList.toJS().first_name}
                                    onChange={e => this.handleChange(e, "first_name")}
                                />
                                <TextField
                                    required
                                    label="Last name"
                                    className="textField"
                                    margin="dense"
                                    variant="outlined"
                                    value={infoList.toJS().last_name}
                                    onChange={e => this.handleChange(e, "last_name")}
                                />
                                <TextField
                                    required
                                    label="Email Address"
                                    className="textField"
                                    margin="dense"
                                    variant="outlined"
                                    value={infoList.toJS().email}
                                    onChange={e => this.handleChange(e, "email")}
                                />
                                <TextField
                                    label="Phone Number"
                                    className="textField"
                                    margin="dense"
                                    variant="outlined"
                                    value={infoList.toJS().phone}
                                    onChange={e => this.handleChange(e, "phone")}
                                />
                                {workInfoView()}
                            </div>
                            {workFrom()}
                            {roleFrom()}
                        </form>
                        <div className="line"></div>
                        <Button variant="contained" color="primary" onClick={this.handleSaveClick}>SAVE DETAILS</Button>
                    </div>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
        this.props.getInfo();
        this.getUserDept((userData) => {
            this.extTeams(userData)
        })
    }
    handleChange(e, name) {
        const value = e.target.value;
        const { infoList, setInfoList } = this.props;
        let infoListJS = infoList.toJS();
        infoListJS[name] = value;
        setInfoList(fromJS(infoListJS))
    }
    handleDateChange() {

    }
    handleSaveClick() {
        const { infoList, saveInfo } = this.props;
        let infoListJS = infoList.toJS();
        let params = {
            first_name: infoListJS.first_name,
            last_name: infoListJS.last_name,
            email: infoListJS.email,
            phone: infoListJS.phone,
        }
        console.log(infoList.toJS())
        saveInfo(params, (success) => {
            if (success) {
                this.showToast("Saved successfully", "success");
            } else {
                this.showToast("Save failed", "error");
            }
        })
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    extTeams(userObj) {
        const roleArr = userObj.roles;
        if (!roleArr) return;
        let myTeams = [];
        for (const obj of roleArr) {
            myTeams.push(this.teamFromat(obj));
        }
        this.setState(() => ({
            myTeams
        }));
    }
    teamFromat(roleObj) {
        const deptObj = roleObj.department;
        const teamObj = roleObj.team;
        const roleId = roleObj.role.id;
        if (deptObj) {
            return deptObj.office + " - " + deptObj.name + " (" + this.changeRoleName(roleId) + ")";
        } else if (teamObj) {
            return teamObj.dept.office + " - " + teamObj.dept.name + " - " + teamObj.name + " (" + this.changeRoleName(roleId) + ")";
        } else {
            return "";
        }
    }
    changeRoleName(roleId) {
        if (roleId === 1) {
            return "admin";
        } else if (roleId === 2) {
            return "dept manager";
        } else if (roleId === 3) {
            return "team leader";
        } else if (roleId === 4) {
            return "billing manager";
        } else if (roleId === 5) {
            return "client manager";
        } else if (roleId === 6) {
            return "staff";
        } else {
            return "";
        }
    }
    //------------request---------------
    getUserDept(callback) {
        instance.get(BASE_URL + 'users/current').then((res) => {
            const userData = res.data.data;
            callback(userData);
        })
    }
}

// store映射
const mapStateToProps = (state) => {
    return {
        infoList: state.getIn(['myProfile', 'infoList']),
    }
}
const mapDispathToProps = (dispath) => {
    return {
        getInfo: () => {
            dispath(reducer.getInfo());
        },
        setInfoList: (value) => {
            dispath(reducer.setInfoList(value));
        },
        saveInfo: (params, callback) => {
            dispath(reducer.saveInfo(params, callback));
        },
    }
}

export default connect(mapStateToProps, mapDispathToProps)(withRouter(MyProfile));